import Table from 'src/javascripts/components/Table';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import * as filestack from 'filestack-js';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

export default class SurveysCollectionDocumentsIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');
    let activeUploads = 0;

    // Function to check if all file uploads are complete
    function checkIfAllUploadsComplete() {
      if (activeUploads === 0) {
        let surveySlug = $('.survey-document-filepicker').attr('data-slug');
        let url = $('.survey-document-filepicker').data('redirect-url');
        if (typeof url === 'undefined') {
          url = '/' + accountUrl + '/surveys/' + surveySlug + '/documents';
        }
        return Turbo.visit(url);
      }
    }

    // Upload file
    // Set environment and account id for AWS path vars
    $('.survey-document-filepicker').each(function(i, elem) {
      let fileInput     = $(elem);
      let filePicker    = $(this);
      let env           = fileInput.data("env");
      let primaryColor  = fileInput.data("primary-color");
      const allowedExtensions = [
        'txt', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'xlsm', 'csv', 'png', 'jpg', 'jpeg', 'html', 'htm'
      ];

      fileInput.fileupload({
        fileInput:        fileInput,
        url:              fileInput.data('url'),
        type:             'POST',
        autoUpload:       true,
        formData:         fileInput.data('form-data'),
        paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
        dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
        replaceFileInput: false,

        // Add file progress bars
        add: function(e, data) {
          $('.file-upload-progress').removeClass('d-none');
          data.contexts = [];

          // Validate all files
          const invalidFiles = [];
          $.each(data.files, function(index, file) {
            const fileName = file.name || '';
            const ext = fileName.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(ext)) {
              invalidFiles.push(fileName);
            }
          });

          if (invalidFiles.length > 0) {
            const displayExtensions = allowedExtensions.map(ext => '.' + ext).join(', ');
            ToastCustom({
              title: 'File type not allowed',
              message: 'File type not allowed. Allowed types are: <br />' + displayExtensions,
              delay: 7000,
              type: 'warning'
            });
            return false;
          }

          activeUploads += data.files.length;
          $.each(data.files, function(index, file) {
            // Create a new progress bar for this file
            let progressBar = $("<div class='bar'></div>");
            let barContainer = $("<div class='progress mb-2' style='height: 20px;'></div>").append(progressBar);
            // Optional: show filename
            let label = $("<div class='small text-muted mb-1'></div>").text(file.name);
            $('.file-upload-progress').append(label, barContainer);
            // Style bar
            progressBar
              .css('background', fileInput.data('primary-color'))
              .css('width', '0%')
              .css('display', 'block')
              .css('height', '20px');
            // Store progressBar on context for this file
            data.contexts.push(progressBar);
          });

          // Begin upload
          data.submit();
        },

        progress: function(e, data) {

          // Progress per file
          if (data.contexts) {
            let progress = parseInt(data.loaded / data.total * 100, 10);
            data.contexts.forEach(function(progressBar) {
              progressBar.css('width', progress + '%');
            });
          }

          // If all at 100%, spinner
          let percents = [];
          $('.bar').each(function() {
            let barWidth = $(this).css('width').replace('px','');
            let progWidth = $(this).closest('.progress').css('width').replace('px','');
            percents.push(parseInt(barWidth / progWidth * 100, 10));
          })
          let min = Math.min.apply(Math, percents);
          if (min === 100) {
            $('.modal-body').css('opacity', 0.2);
            Spinner($('.modal'));
          }

        },

        done: function(e, data) {
          let key = $(data.jqXHR.responseXML).find("Key").text();
          let surveySlug = fileInput.attr('data-slug');

          fileInput.closest('.filepicker-container .filepicker-label').addClass('opaque');
          Spinner(fileInput.closest('.filepicker-container'));

          let url = '/' + accountUrl + '/surveys/' + surveySlug + '/documents.json';
          let formData = { file: { key: key } };

          $.ajax({
            type: 'POST',
            url: url,
            dataType: "application/json",
            data: formData,
            complete(result) { 
              activeUploads--;
              checkIfAllUploadsComplete();
            },
          });

        },

        fail: function(e, data) {
          if (data.contexts) {
            data.contexts.forEach(function(progressBar) {
              progressBar
                .css("background", "red")
                .text("Failed");
            });
          }
        }

      });

    });


  }

}
